import {IBaseFetchOptions, IBaseParameters, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	GET_REFINEMENT_IMAGES: {
		path: 'refinement-images',
		method: 'GET'
	}
};

export interface IGetRefinementImagesOptions extends IBaseFetchOptions {
	parameters?: IBaseParameters & {
		c_folder: string;
		c_presentationIds: string;
		c_fileExt?: string;
	}
}

export interface IRefinementImage {
	id: string;
	imageUrl: string;
}

export interface IGetRefinementImagesResponse extends IBaseResponse {
	refinementImages?: IRefinementImage[];
}
